import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useCart } from "../../context/CartContext";
import CartItemsInCart from "../canvas/CartItemsInCart";
import cartAPI from "../../api/cartApi";
import CouponList from "../others/CouponList";
import Breadcrump from "../../components/Breadcrump";
import { showError, showSuccess } from "../../utils/toastUtils";
import Summary from "./common/Summary";
import { handleApiValidationError } from "../../utils/apiErrorHandler";

function Cart() {
  const { cartItems, fetchCart, cartSummary } = useCart();

  const [couponList, setCouponList] = useState([]);
  const [couponCode, setCouponCode] = useState(cartSummary?.couponCode || "");
  const [activeCoupon, setActiveCoupon] = useState(
    cartSummary?.couponCode || "",
  );

  useEffect(() => {
    fetchCouponCodes();
  }, []);

  useEffect(() => {
    setCouponCode(cartSummary?.couponCode || "");
    setActiveCoupon(cartSummary?.couponCode || "");
  }, [cartSummary]);

  const fetchCouponCodes = async () => {
    try {
      const res = await cartAPI.showCoupon();
      if (res.code === 200) {
        setCouponList(res.data);
      }
    } catch (err) {}
  };

  // Apply Coupon Instant UI
  const applyCoupon = async (codeParam) => {
    const codeToApply = codeParam || couponCode;

    // instantly button update
    setActiveCoupon(codeToApply);
    setCouponCode(codeToApply);

    try {
      const res = await cartAPI.applyCoupon({
        couponCode: codeToApply,
      });

      if (res.code === 200) {
        await fetchCart();
        showSuccess("Coupon applied successfully");
      } else {
        setActiveCoupon("");
        showError(res.message || "Invalid coupon code");
      }
    } catch (err) {
      setActiveCoupon("");
      handleApiValidationError(err, showError);
    }
  };

  const removeCoupon = async () => {
    try {
      const res = await cartAPI.removeCoupon();

      if (res.code === 200) {
        setActiveCoupon("");
        setCouponCode("");
        fetchCart();
        showSuccess("Coupon removed");
      }
    } catch (err) {}
  };

  return (
    <>
      <Breadcrump title="Cart" />

      <div className="s-contact flat-spacing-13">
        <div className="container">
          {cartItems && cartItems.length > 0 ? (
            <div className="row">
              <div className="col-xl-8">
                <div className="tf-page-cart-main">
                  <form className="form-cart">
                    <table className="table-page-cart">
                      <thead>
                        <tr>
                          <th>Product</th>
                          <th>MRP</th>
                          <th>Price</th>
                          <th>Quantity</th>
                          <th>Total</th>
                        </tr>
                      </thead>

                      <tbody>
                        {cartItems.map((item) => (
                          <CartItemsInCart key={item._id} item={item} />
                        ))}
                      </tbody>
                    </table>

                    <div className="box-ip-discount">
                      <div className="discount-ip">
                        <input
                          className="value-discount"
                          type="text"
                          placeholder="Discount code"
                          value={couponCode}
                          onChange={(e) => setCouponCode(e.target.value)}
                        />

                        <button
                          type="button"
                          className="tf-btn btn-out-line-dark-2"
                          onClick={
                            activeCoupon ? removeCoupon : () => applyCoupon()
                          }
                        >
                          {activeCoupon ? "Remove" : "Apply"}
                        </button>
                      </div>

                      {couponList && couponList.length > 0 && (
                        <div className="couponlist mt-3">
                          <div className="row g-3">
                            {couponList.map((items) => (
                              <div className="col-md-12" key={items._id}>
                                <div className="coupon-ticket coupon-list-ui">
                                  {/* Left Side */}
                                  <div className="coupon-left-cart">
                                    <span>
                                      {items?.discountType === "PERCENTAGE"
                                        ? `${items?.discountValue}%`
                                        : `FLAT ${items?.discountValue}`}
                                    </span>
                                  </div>

                                  <div className="coupon-cart-divider"></div>

                                  {/* Right Side */}
                                  <div className="coupon-right flex-grow-1">
                                    <h6>{items?.title}</h6>
                                    <p>Code: {items?.code}</p>
                                  </div>

                                  {/* Apply Button */}
                                  <div className="coupon-action">
                                    <button
                                      type="button"
                                      className={`coupon-btn ${
                                        activeCoupon === items.code
                                          ? "applied"
                                          : ""
                                      }`}
                                      onClick={() => applyCoupon(items.code)}
                                    >
                                      {activeCoupon === items.code
                                        ? "Applied"
                                        : "Apply"}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  </form>
                </div>
              </div>

              <div className="col-xl-4">
                <div className="tf-page-cart-sidebar">
                  <form className="cart-box order-box">
                    <div className="cart-summary-container">
                      <div className="title text-lg fw-medium">
                        Order Details
                      </div>

                      <hr />

                      <Summary
                        cartItems={cartItems}
                        cartSummary={cartSummary}
                      />


                      <div className="btn-order">
                        <Link
                          className="shop-btn w-100 text-center"
                          to="/checkout"
                        >
                          Checkout
                        </Link>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          ) : (
            <div className="my-acount-content account-orders mb-5">
              <div className="account-orders-wrap">
                <div className="account-no-orders-wrap">
                  <img
                    src={`${process.env.PUBLIC_URL}/images/section/account-no-order.png`}
                    alt="No Order Found"
                  />

                  <div className="display-sm fw-medium title">
                    You haven’t added any item in your cart yet
                  </div>

                  <Link
                    to="/shop"
                    className="tf-btn animate-btn d-inline-flex bg-dark-2 justify-content-center"
                  >
                    Shop Now
                  </Link>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default Cart;
